import { useQuery, useMutation, gql } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { addProductIdToWaitlist, setOpenLoginModal } from '../store/actions';

function useHandleAddToWaitlist() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.Auth.isAuthenticated);

  const { loading: loadingWaitlist, data: dataWaitlist } = useQuery(
    ALL_WAITLISTED_PRODUCTS_BY_CURRENT_USER,
    {
      fetchPolicy: 'network-only',
      skip: !isAuthenticated
    }
  );

  const [addToWaitlistMutation, { loading: loadingAdd }] = useMutation(
    WAITLIST_PRODUCT,
    {
      refetchQueries: [{ query: ALL_WAITLISTED_PRODUCTS_BY_CURRENT_USER }]
    }
  );

  const [removeFromWaitlist, { loading: loadingDelete }] = useMutation(
    UNWAITLIST_PRODUCT,
    {
      refetchQueries: [{ query: ALL_WAITLISTED_PRODUCTS_BY_CURRENT_USER }]
    }
  );

  const checkIfInWaitlist = productId => {
    if (dataWaitlist) {
      return dataWaitlist.allWaitlistedProductsByCurrentUser.some(
        product => parseInt(product.id) === parseInt(productId)
      );
    }
  };

  const handleWaitlist = productId => {
    if (!isAuthenticated) {
      dispatch(addProductIdToWaitlist(productId));
      dispatch(setOpenLoginModal(true));
    } else {
      if (!checkIfInWaitlist(productId)) {
        addToWaitlistMutation({ variables: { product_id: productId } });
      } else {
        removeFromWaitlist({ variables: { product_id: productId } });
      }
    }
  };

  const loading = loadingWaitlist || loadingAdd || loadingDelete;

  return [handleWaitlist, { loading, checkIfInWaitlist }];
}

export default useHandleAddToWaitlist;

const WAITLIST_PRODUCT = gql`
  mutation waitlistProduct($product_id: ID!) {
    waitlistProduct(product_id: $product_id) {
      id
      slug
    }
  }
`;

const UNWAITLIST_PRODUCT = gql`
  mutation unwaitlistProduct($product_id: ID!) {
    unwaitlistProduct(product_id: $product_id) {
      id
      slug
    }
  }
`;

const ALL_WAITLISTED_PRODUCTS_BY_CURRENT_USER = gql`
  query allWaitlistedProductsByCurrentUser {
    allWaitlistedProductsByCurrentUser {
      id
      name
      sku
      slug
    }
  }
`;
